export const MFAMethod = {
  TOTP: "TOTP",
  SMS: "SMS",
  NOMFA: "NOMFA",
} as const;

export type MFAMethod = (typeof MFAMethod)[keyof typeof MFAMethod];

export const MFAType = {
  SOFTWARE_TOKEN_MFA: "SOFTWARE_TOKEN_MFA",
  SMS_MFA: "SMS_MFA",
} as const;

export type MFAType = (typeof MFAType)[keyof typeof MFAType];
